define('shared/util/queryPersistence',['$', 'shared/lib/RSVP', 'shared/lib/URI', 'shared/lib/cookie'], function($, RSVP, URI, cookie ){
    'use strict';

    var CONSTANT = {
        hoTransactionId: 'hoTransactionId',
        gclid: 'gclid',
        ruboid: 'ruboid',
        utm_source: 'utm_source',
        utm_medium: 'utm_medium',
        utm_campaign: 'utm_campaign',
        utm_term: 'utm_term',
        utm_content: 'utm_content',
        adgroup: 'adgroup',
        referredby: 'referredby',
        referredfrom: 'referredfrom'
    };

    var initialized = null;

    function init(){
        if ( initialized ) {
            return initialized;
        }
        var uri = new URI( location.href );
        var query = uri.query( true );

        function saveSessionCookieIfExistsInUrl(name){
            for(var queryKey in query){
                if(!queryKey || !query.hasOwnProperty(queryKey)) continue;

                if(queryKey.toLowerCase() === name.toLowerCase()){
                    var paramValue = query[queryKey];
                    if(paramValue){
                        cookie.set(name, paramValue, { path: '/' });
                        return;
                    }
                }
            }
        }

        saveSessionCookieIfExistsInUrl(CONSTANT.hoTransactionId);
        saveSessionCookieIfExistsInUrl(CONSTANT.gclid);
        saveSessionCookieIfExistsInUrl(CONSTANT.ruboid);

        saveSessionCookieIfExistsInUrl(CONSTANT.utm_source);
        saveSessionCookieIfExistsInUrl(CONSTANT.utm_medium);
        saveSessionCookieIfExistsInUrl(CONSTANT.utm_campaign);
        saveSessionCookieIfExistsInUrl(CONSTANT.utm_term);
        saveSessionCookieIfExistsInUrl(CONSTANT.utm_content);
        saveSessionCookieIfExistsInUrl(CONSTANT.adgroup);

        saveSessionCookieIfExistsInUrl(CONSTANT.referredby);
        saveSessionCookieIfExistsInUrl(CONSTANT.referredfrom);

        initialized = new RSVP.resolve();
        return initialized;
    }

    var obj = {
        get: function(key){
            return init()
                .then(function(){
                    return RSVP.resolve(cookie.get(key));
                });
        },
        init: init,
        CONSTANT: CONSTANT
    };

    return obj;
});
